import React from 'react';
import { Parallax } from 'react-parallax';
import parralaxImage from '../../assets/quote-background.jpg';
import { ParallaxContainer, ParallaxText } from '../styles/Parallax.styled';

const ParallaxComponent = () => {
  return (
    <Parallax bgImage={parralaxImage} strength={-200} style={{ width: '100%' }}>
      <ParallaxContainer>
        <ParallaxText>
          Develop your career to achieve your <br />
          aspirations and make your dreams a reality!
        </ParallaxText>
      </ParallaxContainer>
    </Parallax>
  );
};

export default ParallaxComponent;
